import React from "react";
import { Modal, Typography, Tag, Space, Button } from "antd";
import {
  AlertOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import MarkdownRenderer from "../components/markdown/MarkdownRenderer";

const { Text, Title } = Typography;

interface NoticeItem {
  id: number;
  title: string;
  content: string;
  created_at: string;
  updated_at?: string;
  level: number;
  product: string;
  is_read: boolean;
}

interface NoticePopupProps {
  notice: NoticeItem | null;
  visible: boolean;
  onClose: () => void;
}

const NoticePopup: React.FC<NoticePopupProps> = ({
  notice,
  visible,
  onClose,
}) => {
  // 获取公告等级对应的标签和图标
  const getLevelTag = (level: number) => {
    switch (level) {
      case 1:
        return (
          <Tag color="red" icon={<AlertOutlined />}>
            重要
          </Tag>
        );
      case 2:
        return (
          <Tag color="orange" icon={<ExclamationCircleOutlined />}>
            紧急
          </Tag>
        );
      default:
        return (
          <Tag color="blue" icon={<InfoCircleOutlined />}>
            普通
          </Tag>
        );
    }
  };

  // 格式化日期显示
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleString("zh-CN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (!notice) return null;

  return (
    <Modal
      open={visible}
      title={
        <div style={{ display: "flex", alignItems: "center" }}>
          <i
            className="ri-notification-4-line"
            style={{ fontSize: "20px", color: "#1890ff", marginRight: "8px" }}
          />
          <span>系统公告</span>
        </div>
      }
      width={700}
      footer={[
        <Button key="close" onClick={onClose}>
          关闭
        </Button>,
      ]}
      onCancel={onClose}
      style={{ top: 20 }}
      styles={{
        body: {
          maxHeight: "calc(100vh - 200px)",
          overflow: "auto",
        },
      }}
    >
      <div style={{ padding: "8px 0 16px" }}>
        <Title level={4} style={{ margin: "0 0 16px 0" }}>
          {notice.title}
        </Title>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "16px",
          }}
        >
          <Space>
            {getLevelTag(notice.level)}
            <Text type="secondary">
              发布时间: {formatDate(notice.created_at)}
            </Text>
          </Space>
        </div>
        <div
          style={{
            padding: "16px",
            background: "#f9f9f9",
            borderRadius: "8px",
          }}
        >
          <MarkdownRenderer content={notice.content} />
        </div>
      </div>
    </Modal>
  );
};

export default NoticePopup;
